export default __webpack_public_path__ + "static/media/player-01.d1da1978.webp";